import { Position } from "@/models/positions.model";

export default function positionToVariantFilter(position?: Position): string {
  const positionCode = position && position.code;

  switch (positionCode) {
    case "goalkeeper":
      return "orange";
    case "defender":
      return "green";
    case "striker":
      return "red";
    case "midfield":
    default:
      return "blue";
  }
}
